/**
 * depotZones — zones du QG (vue aérienne + panneau carte du réseau).
 * Extrait de pages/Depot.jsx (14/06/2026) pour être partagé entre la scène
 * aérienne (DepotScene) et le panneau d'évolutions QG de la carte du réseau
 * (HqZoneUpgrades). Chaque zone référence un investissement principal
 * (data/investments.js) et ses évolutions associées.
 */
import { Warehouse, Fuel, Truck, ArrowUpRight, Thermometer, HardHat, Box, AlertTriangle, BatteryCharging, Wrench } from 'lucide-react';

export const DEPOT_ZONES = [
  {
    id: 'garage', nameKey: 'depot_zone_garage_name', descriptionKey: 'depot_zone_garage_desc',
    capacityKey: 'depot_zone_garage_capacity', icon: Truck, investmentId: null, baseActive: true,
    upgrades: [
      { investmentId: 'inv-depot-01', labelKey: 'depot_upg_inv_depot_01_label', descriptionKey: 'depot_upg_inv_depot_01_desc' },
      // 17/06/2026 — Extension logistique (+100 km de rayon couverture).
      // Équivalent QG de l'évolution `radiusExtension` (DEPOT_UPGRADES).
      { investmentId: 'inv-depot-06', labelKey: 'depot_upg_inv_depot_06_label', descriptionKey: 'depot_upg_inv_depot_06_desc' },
    ],
    color: 'from-blue-500 to-blue-600',
  },
  {
    id: 'quai', nameKey: 'depot_zone_quai_name', descriptionKey: 'depot_zone_quai_desc',
    capacityKey: 'depot_zone_quai_capacity', icon: ArrowUpRight, investmentId: 'inv-depot-04',
    upgrades: [
      // 04/02/2026 — Phase F4 : Quai renforcé pour BTP lourd (prérequis quai dédié).
      { investmentId: 'inv-depot-07', labelKey: 'depot_upg_inv_depot_07_label', descriptionKey: 'depot_upg_inv_depot_07_desc' },
    ],
    color: 'from-emerald-500 to-emerald-600',
  },
  {
    id: 'entrepot', nameKey: 'depot_zone_entrepot_name', descriptionKey: 'depot_zone_entrepot_desc',
    capacityKey: 'depot_zone_entrepot_capacity', icon: Warehouse, investmentId: 'inv-depot-02',
    upgrades: [
      { investmentId: 'inv-depot-03', labelKey: 'depot_upg_inv_depot_03_label', descriptionKey: 'depot_upg_inv_depot_03_desc' },
      // 04/02/2026 — Phase F4 : Entrepôt grand gabarit pour T3+ semi-remorques.
      { investmentId: 'inv-depot-08', labelKey: 'depot_upg_inv_depot_08_label', descriptionKey: 'depot_upg_inv_depot_08_desc' },
    ],
    color: 'from-amber-500 to-amber-600',
  },
  {
    id: 'frigo', nameKey: 'depot_zone_frigo_name', descriptionKey: 'depot_zone_frigo_desc',
    capacityKey: 'depot_zone_frigo_capacity', icon: Thermometer, investmentId: 'inv-depot-05',
    upgrades: [],
    color: 'from-cyan-500 to-cyan-600',
  },
  // 04/02/2026 — Phase F4 : nouvelles zones spécialisées.
  // 05/02/2026 — Q1 retour user prod : zone « point-eau » (transport
  // animaux) supprimée en même temps que la bétaillère.
  {
    id: 'zone-adr', nameKey: 'depot_zone_zone_adr_name', descriptionKey: 'depot_zone_zone_adr_desc',
    capacityKey: 'depot_zone_zone_adr_capacity', icon: AlertTriangle, investmentId: 'inv-depot-10',
    upgrades: [],
    color: 'from-orange-500 to-orange-600',
  },
  {
    id: 'borne-recharge', nameKey: 'depot_zone_borne_recharge_name', descriptionKey: 'depot_zone_borne_recharge_desc',
    capacityKey: 'depot_zone_borne_recharge_capacity', icon: BatteryCharging, investmentId: 'inv-depot-11',
    upgrades: [],
    color: 'from-lime-500 to-lime-600',
  },
  {
    id: 'atelier', nameKey: 'depot_zone_atelier_name', descriptionKey: 'depot_zone_atelier_desc',
    capacityKey: 'depot_zone_atelier_capacity', icon: Wrench, investmentId: 'inv-depot-12',
    upgrades: [
      // 09/02/2026 — Q2 Lot E user prod : panneaux photovoltaïques QG
      // (parité avec `solar` des satellites). Loyer QG -20 %.
      { investmentId: 'inv-depot-solar', labelKey: 'depot_upg_inv_depot_solar_label', descriptionKey: 'depot_upg_inv_depot_solar_desc' },
    ],
    color: 'from-stone-500 to-stone-600',
  },
  {
    id: 'pompe', nameKey: 'depot_zone_pompe_name', descriptionKey: 'depot_zone_pompe_desc',
    capacityKey: 'depot_zone_pompe_capacity', icon: Fuel, investmentId: 'inv-energy-02',
    upgrades: [
      { investmentId: 'inv-energy-01', labelKey: 'depot_upg_inv_energy_01_label', descriptionKey: 'depot_upg_inv_energy_01_desc' },
      // 04/02/2026 — Phase F4 : inv-energy-03 (Contrat fournisseur carburant)
      // déplacé vers le rôle support « achats », plus géré ici.
    ],
    color: 'from-red-500 to-red-600',
  },
];
